/**
 * Lightweight skeleton shown while the lazy-loaded dashboard chunk
 * fetches. Same shape as the IdentityGate "Loading…" treatment so
 * the visual feel is consistent across the app's top-level routes.
 */
export function DashboardSkeleton() {
  return (
    <div className="min-h-[60vh] flex items-center justify-center text-muted-foreground text-sm">
      Loading dashboard…
    </div>
  )
}
